export default __webpack_public_path__ + "static/media/grass.bdc5b553.svg";